import { getGroups } from './getGroups';
import { Group } from './types';

const PAGE_SIZE = 1_000;

type GroupsPage = {
  data: Group[];
  meta?: { total: number };
};

export const getAllGroups = async ({
  search,
}: { search?: string } = {}): Promise<Group[]> => {
  const accumulated: Group[] = [];

  const firstPage = (await getGroups({
    limit: PAGE_SIZE,
    offset: 0,
    ...(search ? { search } : {}),
  })) as GroupsPage;
  const total: number = firstPage.meta?.total ?? firstPage.data.length;

  accumulated.push(...firstPage.data);

  for (let offset = PAGE_SIZE; offset < total; offset += PAGE_SIZE) {
    const page = (await getGroups({
      limit: PAGE_SIZE,
      offset,
      ...(search ? { search } : {}),
    })) as GroupsPage;
    accumulated.push(...page.data);
  }

  return accumulated;
};
